export const env = {
  REACT_APP_APIKEY:'AIzaSyDw-RfaTbgU5IImFuHBuoQXlKyXnXZwMx0',
  REACT_APP_AUTHDOMAIN:'aldg-otd.firebaseapp.com',
  REACT_APP_PROJECTID:'aldg-otd',
  REACT_APP_STORAGEBUCKET:'aldg-otd.appspot.com',
  REACT_APP_MESSAGINGSENDERID:'873768394101',
  REACT_APP_APPID:'1:873768394101:web:af878831d317fb6e94473c',
  REACT_APP_MEASUREMENTID:'G-6Y1TB1N0P1'
};